import { useContext } from "react";

import { Tabs, TabsPanel } from "@salesforce/design-system-react";

import EmbedInEmailContext from "../../contexts/embedInEmailContext";

import { Gifs } from "./Gifs";
import { Thumbnails } from "./Thumbnails";
import { ThumbnailType } from "vimeo";

interface Props {
    uri: string;
    name: string;
}

export function ChooseAsset(props: Props) {
    const [embedInEmailContextState, setEmbedInEmailContextState] =
        useContext(EmbedInEmailContext);

    function onSelect(
        type: ThumbnailType,
        imgUrl: string,
        imgUrlWithPlayButton: string,
        isPortrait: boolean
    ) {
        setEmbedInEmailContextState({
            ...embedInEmailContextState,
            selectedImgType: type,
            imgUrl,
            imgUrlWithPlayButton,
            isPortraitImage: isPortrait,
        });
    }

    return (
        <Tabs className="choose-asset-tabs">
            <TabsPanel label="GIFs">
                <Gifs videoUri={props.uri} onSelect={onSelect} />
            </TabsPanel>
            <TabsPanel label="Thumbnails">
                <Thumbnails videoUri={props.uri} onSelect={onSelect} />
            </TabsPanel>
        </Tabs>
    );
}
